
import React from "react";
import { formatDate, formatRelativeTime } from "@/utils/formatDate";
import { Clock, User } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface NotificationMetadataProps {
  userName: string;
  createdAt: string;
  updatedAt: string;
}

const NotificationMetadata = ({ 
  userName, 
  createdAt, 
  updatedAt 
}: NotificationMetadataProps) => {
  const isEdited = new Date(updatedAt).getTime() > new Date(createdAt).getTime() + 1000; // Add 1 second buffer
  
  return (
    <div className="flex flex-col space-y-1 text-sm text-muted-foreground">
      <div className="flex items-center">
        <User className="mr-1 h-3 w-3" />
        <span>Aangemaakt door {userName}</span>
      </div>
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center cursor-help">
              <Clock className="mr-1 h-3 w-3" />
              <span>Aangemaakt {formatRelativeTime(createdAt)}</span>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>{formatDate(createdAt)}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      
      {isEdited && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center cursor-help">
                <Clock className="mr-1 h-3 w-3" />
                <span>Laatst bijgewerkt {formatRelativeTime(updatedAt)}</span>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>{formatDate(updatedAt)}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
};

export default NotificationMetadata;
